import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Visually matched to libs/ui/shared/src/Card.module.scss. Padding steps at
 * Tailwind's `lg` (64rem) where the SCSS steps at 71rem, so padding and
 * typography do not switch together. Ground and text colour are set together:
 * inheriting a foreground from an inverse band gave slate-50 text on white.
 * RainbowCard is not ported.
 */
export const card = cva('flex rounded-lg border border-slate-200 bg-white text-slate-800', {
  variants: {
    padding: {
      sm: 'p-4',
      lg: 'p-5 lg:p-8',
      none: '',
    },
    elevation: {
      medium: 'shadow-lg',
      none: '',
    },
    interactive: {
      true: 'cursor-pointer transition-colors duration-200 hover:border-periwinkle',
    },
  },
  defaultVariants: {
    padding: 'lg',
    elevation: 'medium',
  },
});

export type CardVariants = VariantProps<typeof card>;
